import React from 'react';
import Prototype from 'prop-types';


const ButtonContained = ({ disabled, buttonName, type, children, onClick, loading }) => {
    return (
        <button disabled={disabled} onClick={onClick} type={type} className="btn mt-3 submit-btn" variant="primary" >{loading ? children : buttonName}</button>
    );
}
ButtonContained.protoType = {
    disabled: Prototype.bool
}
export default ButtonContained;